// extracted by mini-css-extract-plugin
export default {"root":"PlasmicHeroCityImg_root__Nzu4o","img":"PlasmicHeroCityImg_img__Fd1Hg"};